angular.module('unica_feedback_category.feedback_category_controllers', [])

.controller('FeedbackCategoryBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.showDelete = true;
});